import CciSection from './CciSection.vue'
import { mapGetters } from 'vuex'
import Swiper from 'swiper/bundle'

export default {
  data () {
    return { scroller: null }
  },
  created () {
    window.addEventListener('resize', this.didResize)
  },
  mounted () {
    this.applySettings(this.settings)
    this.initializeScroller()
  },
  computed: {
    ...mapGetters({
      sections: 'getSections',
      currentSection: 'getCurrentSection',
      pages: 'getPages',
      settings: 'getSettings'
    })
  },
  watch: {
    settings: function (newValue) {
      this.applySettings(newValue)
    },
    sections: function () {
      this.initializeScroller()
    },
    currentSection: function (newValue) {
      if (this.scroller !== null && !this.isSectionElemInView(newValue.id)) {
        var index = this.sections.indexOf(newValue)
        this.scroller.slideTo(index)
      }
    },
    '$route': function (newValue, oldValue) {
      if (oldValue.name === 'articles' || oldValue.name === 'articles-mobile') {
        this.initializeScroller()
        let section = this.getSectionFromPageParam(newValue.params.pageNr)
        this.$store.commit('setCurrentSection', section)
      }
    }
  },
  methods: {
    applySettings (settings) {
      if (settings !== undefined) {
        var sectionContainer = document.getElementsByClassName('section-container')[0]
        sectionContainer.style.backgroundColor = settings.sectionsBarBackgroundColor
        sectionContainer.style.borderBottomColor = settings.sectionsBarBorderColor
        var prev = document.getElementsByClassName('section-prev')[0]
        var next = document.getElementsByClassName('section-next')[0]
        prev.style.backgroundColor = settings.sectionsBarBackgroundColor
        next.style.backgroundColor = settings.sectionsBarBackgroundColor
        prev.style.boxShadow = '1px 0px 2px 0px' + settings.sectionsBarBorderColor;
        next.style.boxShadow = '-1px 0px 2px 0px' + settings.sectionsBarBorderColor;
      }
    },
    initializeScroller() {
      this.$nextTick( function () {

        if (this.scroller !== null) {
          this.scroller.destroy()
          this.scroller = null
        }

        this.scroller = new Swiper ('.section-swiper-container', {
          direction: 'horizontal',
          slidesPerView: 'auto',
          freeMode: true,
          freeModeSticky: true,
          slideClass: 'section-swiper-slide',
          wrapperClass: 'section-swiper-wrapper',
          grapCursor: true,
          navigation: {
            nextEl: '.section-next',
            prevEl: '.section-prev'
          }
        })

        var index = this.sections.indexOf(this.currentSection)
        this.scroller.slideTo(index)

        this.didResize()
      })
    },
    getSectionFromPageParam(pageNr) {
      for (var i = 0; i < this.pages.length; i++) {
        if (this.pages[i].secondPage !== null) {
          if (this.pages[i].secondPage.pageNumber === pageNr || this.pages[i].firstPage.pageNumber === pageNr) {
            return this.pages[i].secondPage.sections[0]
          }
        }
        if (this.pages[i].firstPage.pageNumber === pageNr) {
          return this.pages[i].firstPage.sections[0]
        }
      }
    },
    didResize() {
      if (this.$route.name !== 'pages' || this.isPhone()) {
        return
      }
      let pageWidth = document.documentElement.clientWidth
      let swiperElems = document.getElementsByClassName('section-swiper-slide')
      var swiperElemsWidth = 0

      for (var i = 0; i < swiperElems.length; i++) {
        swiperElemsWidth += swiperElems[i].clientWidth
      }

      if (swiperElemsWidth < pageWidth - 70 && swiperElems.length !== 0) {
        document.getElementById('section-prev').classList.add('swiper-button-disabled')
        document.getElementById('section-next').classList.add('swiper-button-disabled')
        document.getElementById('section-nav').style.display = 'none'
        document.getElementById('section-swiper-container').style.padding = '0'
      } else {
        document.getElementById('section-prev').classList.remove('swiper-button-disabled')
        document.getElementById('section-next').classList.remove('swiper-button-disabled')
        document.getElementById('section-nav').style.display = 'block'
        document.getElementById('section-swiper-container').style.paddingLeft = '32px'
        document.getElementById('section-swiper-container').style.paddingRight = '32px'
      }
    },
    isSectionElemInView (sectionId) {
      for (var key in this.$refs) {
        if (Object.prototype.hasOwnProperty.call(this.$refs, key)) {
          let ref = this.$refs[key][0]
          if (ref.$vnode.data.key === sectionId) {
            let elem = ref.$el
            let bounding = elem.getBoundingClientRect()
            return (
              bounding.top >= 0 &&
              bounding.left >= 0 &&
              bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
              bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
            )
          }
        }
      }
    }
  },
  components: {
    CciSection
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.didResize)
    if (this.scroller !== null) {
      this.scroller.destroy()
      this.scroller = null
    }
  }
}
